import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { Helmet } from "react-helmet-async";
import CertificationsHeader from "../../components/header/certifications-header";
import ContainerLayOut from "../../layouts/two-columns/container-layout";
import NavBarStyleComponent from "../../containers/components/certifications-navbar-style.component"
import ChatComponent from "../../components/chat-component";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import LoadingComp from "../../components/re-usable/loading/loading";
import PageNotFound from "../errors/page-not-found";

const CertificationsLanding = () => {
  const { "*": urlPath } = useParams();
  const formattedPath = urlPath?.replaceAll("/", "%2F");
  const breadcrumbPath = `certifications%2F${formattedPath}`;
  const path = `%2F${breadcrumbPath}`;
  const isHome = urlPath ? (urlPath?.split("/")?.length === 1) : false;
  const isRoot = urlPath === "";

  const dispatch = useAppDispatch();
  const { RapsEuropeData, RapsEuropeLoading: pageMenuLoading, pageNotFound } = useSelector((state: RootState) => state.rapsEurope);
  const [topHtmlString, setTopHtmlString] = useState("");
  const [bottomHtmlString, setBottomHtmlString] = useState("");
  const [scriptHtmlString, setScriptHtmlString] = useState("");
  const [newBreadcrumbPath, setNewBreadcrumbPath] = useState(breadcrumbPath);
  const [siteNavPath, setSiteNavPath] = useState("")
  //const { AccordionData } = useSelector((state: RootState) => state.Accordion);

  const [isPublished, setIsPublished] = useState(false);
  const [isPageNotFound, setIsPageNotFound] = useState(!pageMenuLoading && pageNotFound);

  useEffect(() => {
    dispatch(retrievePageMenu(path));
    //dispatch(retrieveAccordion(`${path}%2FAccordions`));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]?.result) {
      if (RapsEuropeData[0]?.result[0]?.description) setTopHtmlString(RapsEuropeData[0]?.result[0].description);
      if (RapsEuropeData[0]?.result[0]?.councilDescription) setBottomHtmlString(RapsEuropeData[0]?.result[0].councilDescription);

      setIsPublished(true);
    }
    else if (!pageMenuLoading && pageNotFound) {
      setIsPageNotFound(true);
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (isPublished) {
      if (RapsEuropeData[0].result[0]?.javaScriptField) setScriptHtmlString(RapsEuropeData[0].result[0]?.javaScriptField);
    }
  }, [isPublished])

  useEffect(() => {
    let certPath = ``;
    if (!isRoot) certPath = `%2F` + urlPath?.split("/")[0];
    let fullPath = `%2Fcertifications` + certPath + `%2FSite-Nav`;
    setSiteNavPath(fullPath);
  }, [siteNavPath]);

  useEffect(() => {
    setNewBreadcrumbPath(breadcrumbPath);
  }, [newBreadcrumbPath]);

  // Check Hash in router and scroll to the element
  //useEffect(() => {
  //  if (location.hash) {
  //    let divId = location.hash.slice(1);
  //    let elem = document.getElementById(divId);
  //    if (elem) {
  //      elem.scrollIntoView({ behavior: "smooth" });
  //    }
  //  } else {
  //    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //  }
  //}, [topHtmlString]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (isPageNotFound) return <PageNotFound />;
  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <NavBarStyleComponent />
      <CertificationsStyleComponent />
      <CertificationsHeader siteNavPath={siteNavPath} />
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <ContainerLayOut breadcrumbPath={newBreadcrumbPath} isBreadcrumbPath={!(isHome || isRoot)} showAds={true} showSocialMedia={isHome || isRoot ? false : true}>
        <div dangerouslySetInnerHTML={{ __html: topHtmlString }}></div>
        <div dangerouslySetInnerHTML={{ __html: bottomHtmlString }}></div>
        <ChatComponent />
      </ContainerLayOut>
    </>
  )
}

const CertificationsStyleComponent = () => {
  return (
    <>
      <style>
        {`
          .breadcrumb { font-size: 20px; font-weight: 800; }
          .navbar-nav .nav-link:first-child { padding-left: 0; }
          @media screen and (max-width: 990px) {
            .navbar-nav .nav-link:first-child { padding: 35px 0 16px; }
          }
        `}
      </style>
    </>
  );
}

export default CertificationsLanding;